var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-center",on:{"click":function($event){$event.stopPropagation();return _vm.handleUser.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/image/entry/entry_my.png"),"alt":""}}),_c('span',[_vm._v("我的")])])
}
var staticRenderFns = []

export { render, staticRenderFns }